import CurtainModal, {FADE_TIME, OPACITY} from './CurtainModal';

export {FADE_TIME, OPACITY}
export default CurtainModal;
